import * as React from 'react'
import DashboardLayout from '../../../shared/LayoutContainers/DashboardLayout'
import DashboardNavbar from '../../../shared/Navbars/DashboardNavbar'
import ProfessoresForm from './ProfessoresForm'

export default function ListScreen() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ProfessoresForm />
    </DashboardLayout>
  )
}
